export const SI_LOGO_TWO_LINES = '/images/logo/2020/si-logo-2lines-color.svg';
export const SI_LOGO_ICON_ONLY = '/images/logo/2020/si-logomark-color.svg';

export const getCustomLogoPath = (logoId: string) => `/imageservice?id=${logoId}&crop=false&size=-1`;
